import { authRoles } from "../../../auth/authRoles";
import CSR from "./CSR";
import DetailCSR from "./DetailCSR";
import EditCSR from "./EditCSR";
import TambahCSR from "./TambahCSR";

const csrRoutes = [
  {
    path: "/aktifitas_csr/detail/:id",
    exact: true,
    component: DetailCSR,
    auth: authRoles.all,
  },
  {
    path: "/aktifitas_csr/edit/:id",
    exact: true,
    component: EditCSR,
    auth: authRoles.all,
  },
  {
    path: "/aktifitas_csr/tambah",
    exact: true,
    component: TambahCSR,
    auth: authRoles.all,
  },
  {
    path: "/aktifitas_csr",
    exact: true,
    component: CSR,
    auth: authRoles.all,
  },
];

export default csrRoutes;
